import React from 'react';
import PropTypes from 'prop-types';
var GradientSvg = function GradientSvg(_ref) {
  var color = _ref.color,
    open = _ref.open,
    id = _ref.id;
  return /*#__PURE__*/React.createElement("svg", {
    className: "gradient-svg ".concat(open ? 'open' : '').trim(),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "".concat(id, "Gradient"),
    x1: "0",
    x2: "0",
    y1: "0",
    y2: "1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: color,
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: color,
    stopOpacity: "100"
  }))), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#".concat(id, "Gradient)")
  }));
};
GradientSvg.propTypes = {
  color: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired
};
export default GradientSvg;